import * as api from '../api/index';
import { createAction } from 'redux-actions';

export const fetchZoneTemplatesAction = createAction(
  'case.FETCH_ZONE_TEMPLATES'
);
export const fetchZoneTemplatesSuccessAction = createAction(
  'case.FETCH_ZONE_TEMPLATES_SUCCESS'
);
export const copyZoneAction = createAction('case.FETCH_COPY_ZONE');
export const copyZoneActionSuccess = createAction(
  'case.FETCH_COPY_ZONE_SUCCESS'
);

export const fetchZoneTemplates = caseId => (dispatch, getState) => {
  const state = getState();
  if (state.zoneTemplates.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchZoneTemplatesAction());

  if (caseId) {
    return api
      .getZoneTemplates(caseId)
      .then(response => dispatch(fetchZoneTemplatesSuccessAction(response)));
  } else {
    return dispatch(fetchZoneTemplatesSuccessAction([]));
  }
};

export const copyZone = (caseId, zoneTemplateId) => (dispatch, getState) => {
  dispatch(copyZoneAction());

  return api
    .copyZone(caseId, zoneTemplateId)
    .then(response => dispatch(copyZoneActionSuccess(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/actions/zoneTemplates.js